import { useContext } from "react";
import FilterContext, {
  FilterContextValue,
} from "modules/filters/context/filterContext";

export default function useFilterContext<T extends object>() {
  return useContext<FilterContextValue<T> | null>(FilterContext);
}
